@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.admin.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.admin.resources/"

@delegate:ResourceContentHash(-719_352_299)
internal val Res.string.admin_all_listings_empty: StringResource by lazy {
      StringResource("string:admin_all_listings_empty", "admin_all_listings_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 72),
      ))
    }

@delegate:ResourceContentHash(-248_955_361)
internal val Res.string.admin_all_listings_search: StringResource by lazy {
      StringResource("string:admin_all_listings_search", "admin_all_listings_search", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 131, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 107, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83, 69),
      ))
    }

@delegate:ResourceContentHash(-1_507_839_634)
internal val Res.string.admin_all_listings_section: StringResource by lazy {
      StringResource("string:admin_all_listings_section", "admin_all_listings_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 225, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 50),
      ))
    }

@delegate:ResourceContentHash(-352_178_796)
internal val Res.string.admin_approve: StringResource by lazy {
      StringResource("string:admin_approve", "admin_approve", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 292, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 244, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204, 33),
      ))
    }

@delegate:ResourceContentHash(2_143_838_380)
internal val Res.string.admin_audit_actor: StringResource by lazy {
      StringResource("string:admin_audit_actor", "admin_audit_actor", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 330, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 278, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238, 37),
      ))
    }

@delegate:ResourceContentHash(-289_387_470)
internal val Res.string.admin_audit_line: StringResource by lazy {
      StringResource("string:admin_audit_line", "admin_audit_line", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 376, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 316, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276, 52),
      ))
    }

@delegate:ResourceContentHash(-952_587_652)
internal val Res.string.admin_audit_section: StringResource by lazy {
      StringResource("string:admin_audit_section", "admin_audit_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 429, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 369, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 329, 39),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.admin_back_a11y: StringResource by lazy {
      StringResource("string:admin_back_a11y", "admin_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 485, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 421, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 369, 31),
      ))
    }

@delegate:ResourceContentHash(35_704_243)
internal val Res.string.admin_brand: StringResource by lazy {
      StringResource("string:admin_brand", "admin_brand", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 577, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 509, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 441, 31),
      ))
    }

@delegate:ResourceContentHash(253_621_309)
internal val Res.string.admin_brand_sub: StringResource by lazy {
      StringResource("string:admin_brand_sub", "admin_brand_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 525, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 453, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 401, 39),
      ))
    }

@delegate:ResourceContentHash(1_565_539_437)
internal val Res.string.admin_camp_all_canada: StringResource by lazy {
      StringResource("string:admin_camp_all_canada", "admin_camp_all_canada", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 609, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 541, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 473, 45),
      ))
    }

@delegate:ResourceContentHash(1_361_503_785)
internal val Res.string.admin_camp_audience: StringResource by lazy {
      StringResource("string:admin_camp_audience", "admin_camp_audience", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 671, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 591, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 519, 39),
      ))
    }

@delegate:ResourceContentHash(-734_206_650)
internal val Res.string.admin_camp_body_en: StringResource by lazy {
      StringResource("string:admin_camp_body_en", "admin_camp_body_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 719, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 631, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 559, 50),
      ))
    }

@delegate:ResourceContentHash(593_891_082)
internal val Res.string.admin_camp_body_fa: StringResource by lazy {
      StringResource("string:admin_camp_body_fa", "admin_camp_body_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 782, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 682, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 610, 62),
      ))
    }

@delegate:ResourceContentHash(-1_244_290_036)
internal val Res.string.admin_camp_body_fr: StringResource by lazy {
      StringResource("string:admin_camp_body_fr", "admin_camp_body_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 861, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 745, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 62),
      ))
    }

@delegate:ResourceContentHash(941_721_239)
internal val Res.string.admin_camp_capped: StringResource by lazy {
      StringResource("string:admin_camp_capped", "admin_camp_capped", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 944, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 816, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 736, 209),
      ))
    }

@delegate:ResourceContentHash(-390_837_068)
internal val Res.string.admin_camp_channel: StringResource by lazy {
      StringResource("string:admin_camp_channel", "admin_camp_channel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1239, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1063, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1043, 38),
      ))
    }

@delegate:ResourceContentHash(-1_577_390_088)
internal val Res.string.admin_camp_channel_email: StringResource by lazy {
      StringResource("string:admin_camp_channel_email", "admin_camp_channel_email", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1130, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 958, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 946, 40),
      ))
    }

@delegate:ResourceContentHash(-1_626_418_598)
internal val Res.string.admin_camp_channel_push: StringResource by lazy {
      StringResource("string:admin_camp_channel_push", "admin_camp_channel_push", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1179, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1003, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 987, 55),
      ))
    }

@delegate:ResourceContentHash(1_140_743_164)
internal val Res.string.admin_camp_dest: StringResource by lazy {
      StringResource("string:admin_camp_dest", "admin_camp_dest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1594, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1366, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1326, 31),
      ))
    }

@delegate:ResourceContentHash(1_486_182_135)
internal val Res.string.admin_camp_dest_business: StringResource by lazy {
      StringResource("string:admin_camp_dest_business", "admin_camp_dest_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1294, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1098, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1082, 44),
      ))
    }

@delegate:ResourceContentHash(110_591_383)
internal val Res.string.admin_camp_dest_event: StringResource by lazy {
      StringResource("string:admin_camp_dest_event", "admin_camp_dest_event", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1351, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1147, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1127, 37),
      ))
    }

@delegate:ResourceContentHash(1_887_480_356)
internal val Res.string.admin_camp_dest_id: StringResource by lazy {
      StringResource("string:admin_camp_dest_id", "admin_camp_dest_id", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1397, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1193, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1165, 30),
      ))
    }

@delegate:ResourceContentHash(673_033_824)
internal val Res.string.admin_camp_dest_item: StringResource by lazy {
      StringResource("string:admin_camp_dest_item", "admin_camp_dest_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1440, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1224, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1196, 52),
      ))
    }

@delegate:ResourceContentHash(-213_361_679)
internal val Res.string.admin_camp_dest_post: StringResource by lazy {
      StringResource("string:admin_camp_dest_post", "admin_camp_dest_post", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1501, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1277, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1249, 36),
      ))
    }

@delegate:ResourceContentHash(-1_696_164_351)
internal val Res.string.admin_camp_dest_url: StringResource by lazy {
      StringResource("string:admin_camp_dest_url", "admin_camp_dest_url", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1538, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1322, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1286, 39),
      ))
    }

@delegate:ResourceContentHash(1_916_615_471)
internal val Res.string.admin_camp_email_note: StringResource by lazy {
      StringResource("string:admin_camp_email_note", "admin_camp_email_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1646, 357),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1398, 221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1358, 201),
      ))
    }

@delegate:ResourceContentHash(1_131_982_432)
internal val Res.string.admin_camp_failed: StringResource by lazy {
      StringResource("string:admin_camp_failed", "admin_camp_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2004, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1620, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1560, 89),
      ))
    }

@delegate:ResourceContentHash(1_942_478_849)
internal val Res.string.admin_camp_hint: StringResource by lazy {
      StringResource("string:admin_camp_hint", "admin_camp_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2162, 383),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1722, 251),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1650, 235),
      ))
    }

@delegate:ResourceContentHash(515_858_904)
internal val Res.string.admin_camp_send: StringResource by lazy {
      StringResource("string:admin_camp_send", "admin_camp_send", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2609, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2013, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1929, 43),
      ))
    }

@delegate:ResourceContentHash(1_614_198_166)
internal val Res.string.admin_camp_sending: StringResource by lazy {
      StringResource("string:admin_camp_sending", "admin_camp_sending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2546, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1974, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1886, 42),
      ))
    }

@delegate:ResourceContentHash(1_746_275_792)
internal val Res.string.admin_camp_sent: StringResource by lazy {
      StringResource("string:admin_camp_sent", "admin_camp_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2661, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2065, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1973, 51),
      ))
    }

@delegate:ResourceContentHash(1_684_878_306)
internal val Res.string.admin_camp_target_missing: StringResource by lazy {
      StringResource("string:admin_camp_target_missing", "admin_camp_target_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2733, 349),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2121, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2025, 209),
      ))
    }

@delegate:ResourceContentHash(-1_805_893_572)
internal val Res.string.admin_camp_title_en: StringResource by lazy {
      StringResource("string:admin_camp_title_en", "admin_camp_title_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3083, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2395, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2235, 47),
      ))
    }

@delegate:ResourceContentHash(1_239_136_285)
internal val Res.string.admin_camp_title_fa: StringResource by lazy {
      StringResource("string:admin_camp_title_fa", "admin_camp_title_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3147, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2443, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2283, 59),
      ))
    }

@delegate:ResourceContentHash(-1_618_619_019)
internal val Res.string.admin_camp_title_fr: StringResource by lazy {
      StringResource("string:admin_camp_title_fr", "admin_camp_title_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3231, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2507, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2343, 59),
      ))
    }

@delegate:ResourceContentHash(-577_900_148)
internal val Res.string.admin_campaigns_section: StringResource by lazy {
      StringResource("string:admin_campaigns_section", "admin_campaigns_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3319, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2575, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2403, 43),
      ))
    }

@delegate:ResourceContentHash(-1_955_998_596)
internal val Res.string.admin_cancel: StringResource by lazy {
      StringResource("string:admin_cancel", "admin_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3375, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2619, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2447, 28),
      ))
    }

@delegate:ResourceContentHash(2_057_573_385)
internal val Res.string.admin_change_address: StringResource by lazy {
      StringResource("string:admin_change_address", "admin_change_address", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3404, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2652, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2476, 60),
      ))
    }

@delegate:ResourceContentHash(1_613_812_677)
internal val Res.string.admin_change_apply: StringResource by lazy {
      StringResource("string:admin_change_apply", "admin_change_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3469, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2713, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2537, 42),
      ))
    }

@delegate:ResourceContentHash(-2_106_366_263)
internal val Res.string.admin_change_category: StringResource by lazy {
      StringResource("string:admin_change_category", "admin_change_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3524, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2752, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2580, 61),
      ))
    }

@delegate:ResourceContentHash(-25_053_746)
internal val Res.string.admin_change_name: StringResource by lazy {
      StringResource("string:admin_change_name", "admin_change_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3602, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2818, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2642, 53),
      ))
    }

@delegate:ResourceContentHash(-1_197_629_315)
internal val Res.string.admin_change_reject: StringResource by lazy {
      StringResource("string:admin_change_reject", "admin_change_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3656, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2872, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2696, 35),
      ))
    }

@delegate:ResourceContentHash(-1_248_045_332)
internal val Res.string.admin_changes_section: StringResource by lazy {
      StringResource("string:admin_changes_section", "admin_changes_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3692, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2912, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2732, 65),
      ))
    }

@delegate:ResourceContentHash(-1_139_627_416)
internal val Res.string.admin_chip_audit: StringResource by lazy {
      StringResource("string:admin_chip_audit", "admin_chip_audit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3782, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2986, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2798, 32),
      ))
    }

@delegate:ResourceContentHash(-600_875_438)
internal val Res.string.admin_chip_businesses: StringResource by lazy {
      StringResource("string:admin_chip_businesses", "admin_chip_businesses", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3823, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3023, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2831, 45),
      ))
    }

@delegate:ResourceContentHash(-577_900_148)
internal val Res.string.admin_chip_campaigns: StringResource by lazy {
      StringResource("string:admin_chip_campaigns", "admin_chip_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3881, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3065, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2877, 40),
      ))
    }

@delegate:ResourceContentHash(1_019_689_625)
internal val Res.string.admin_chip_claims: StringResource by lazy {
      StringResource("string:admin_chip_claims", "admin_chip_claims", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3934, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3106, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2918, 33),
      ))
    }

@delegate:ResourceContentHash(1_893_889_688)
internal val Res.string.admin_chip_content: StringResource by lazy {
      StringResource("string:admin_chip_content", "admin_chip_content", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3996, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3152, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2952, 42),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.admin_chip_events: StringResource by lazy {
      StringResource("string:admin_chip_events", "admin_chip_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4051, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3199, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2995, 33),
      ))
    }

@delegate:ResourceContentHash(97_009_110)
internal val Res.string.admin_chip_listings: StringResource by lazy {
      StringResource("string:admin_chip_listings", "admin_chip_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4101, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3241, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3029, 43),
      ))
    }

@delegate:ResourceContentHash(375_349_847)
internal val Res.string.admin_chip_members: StringResource by lazy {
      StringResource("string:admin_chip_members", "admin_chip_members", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4165, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3293, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3073, 38),
      ))
    }

@delegate:ResourceContentHash(-122_706_466)
internal val Res.string.admin_chip_reports: StringResource by lazy {
      StringResource("string:admin_chip_reports", "admin_chip_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4204, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3332, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3112, 38),
      ))
    }

@delegate:ResourceContentHash(-909_507_192)
internal val Res.string.admin_chip_requests: StringResource by lazy {
      StringResource("string:admin_chip_requests", "admin_chip_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4255, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3375, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3151, 39),
      ))
    }

@delegate:ResourceContentHash(-652_738_355)
internal val Res.string.admin_claim_contact: StringResource by lazy {
      StringResource("string:admin_claim_contact", "admin_claim_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4311, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3415, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3191, 47),
      ))
    }

@delegate:ResourceContentHash(-1_492_479_029)
internal val Res.string.admin_claim_deny: StringResource by lazy {
      StringResource("string:admin_claim_deny", "admin_claim_deny", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4359, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3463, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3239, 32),
      ))
    }

@delegate:ResourceContentHash(887_214_859)
internal val Res.string.admin_claim_grant: StringResource by lazy {
      StringResource("string:admin_claim_grant", "admin_claim_grant", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4392, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3500, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3272, 45),
      ))
    }

@delegate:ResourceContentHash(-385_811_982)
internal val Res.string.admin_claim_proof_a11y: StringResource by lazy {
      StringResource("string:admin_claim_proof_a11y", "admin_claim_proof_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4450, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3558, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3318, 58),
      ))
    }

@delegate:ResourceContentHash(673_193_810)
internal val Res.string.admin_claim_proof_close_a11y: StringResource by lazy {
      StringResource("string:admin_claim_proof_close_a11y", "admin_claim_proof_close_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4521, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3629, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3377, 60),
      ))
    }

@delegate:ResourceContentHash(1_596_378_409)
internal val Res.string.admin_claim_requested_by: StringResource by lazy {
      StringResource("string:admin_claim_requested_by", "admin_claim_requested_by", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4590, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3702, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3438, 56),
      ))
    }

@delegate:ResourceContentHash(1_311_944_645)
internal val Res.string.admin_claim_role: StringResource by lazy {
      StringResource("string:admin_claim_role", "admin_claim_role", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4848, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3944, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3664, 40),
      ))
    }

@delegate:ResourceContentHash(-1_352_544_872)
internal val Res.string.admin_claim_role_employee: StringResource by lazy {
      StringResource("string:admin_claim_role_employee", "admin_claim_role_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4667, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3759, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3495, 45),
      ))
    }

@delegate:ResourceContentHash(-1_985_728_851)
internal val Res.string.admin_claim_role_manager: StringResource by lazy {
      StringResource("string:admin_claim_role_manager", "admin_claim_role_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4717, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3805, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3541, 44),
      ))
    }

@delegate:ResourceContentHash(-1_521_513_839)
internal val Res.string.admin_claim_role_other: StringResource by lazy {
      StringResource("string:admin_claim_role_other", "admin_claim_role_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4762, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3854, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3586, 38),
      ))
    }

@delegate:ResourceContentHash(1_763_343_469)
internal val Res.string.admin_claim_role_owner: StringResource by lazy {
      StringResource("string:admin_claim_role_owner", "admin_claim_role_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4805, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3893, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3625, 38),
      ))
    }

@delegate:ResourceContentHash(-2_109_870_921)
internal val Res.string.admin_claim_verification: StringResource by lazy {
      StringResource("string:admin_claim_verification", "admin_claim_verification", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4889, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3985, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3705, 56),
      ))
    }

@delegate:ResourceContentHash(-467_096_417)
internal val Res.string.admin_claim_view_proof: StringResource by lazy {
      StringResource("string:admin_claim_view_proof", "admin_claim_view_proof", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4966, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4046, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3762, 54),
      ))
    }

@delegate:ResourceContentHash(-221_993_254)
internal val Res.string.admin_claims_section: StringResource by lazy {
      StringResource("string:admin_claims_section", "admin_claims_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5037, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4109, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3817, 48),
      ))
    }

@delegate:ResourceContentHash(-1_148_748_167)
internal val Res.string.admin_col_actions: StringResource by lazy {
      StringResource("string:admin_col_actions", "admin_col_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5114, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4170, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3866, 37),
      ))
    }

@delegate:ResourceContentHash(1_486_182_135)
internal val Res.string.admin_col_business: StringResource by lazy {
      StringResource("string:admin_col_business", "admin_col_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5164, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4208, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3904, 38),
      ))
    }

@delegate:ResourceContentHash(-788_203_313)
internal val Res.string.admin_col_category: StringResource by lazy {
      StringResource("string:admin_col_category", "admin_col_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5215, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4251, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3943, 38),
      ))
    }

@delegate:ResourceContentHash(943_187_124)
internal val Res.string.admin_col_location: StringResource by lazy {
      StringResource("string:admin_col_location", "admin_col_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5254, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4294, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3982, 38),
      ))
    }

@delegate:ResourceContentHash(-1_144_469_631)
internal val Res.string.admin_col_member: StringResource by lazy {
      StringResource("string:admin_col_member", "admin_col_member", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5297, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4337, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4021, 32),
      ))
    }

@delegate:ResourceContentHash(1_350_988_272)
internal val Res.string.admin_col_role: StringResource by lazy {
      StringResource("string:admin_col_role", "admin_col_role", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5330, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4370, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4054, 30),
      ))
    }

@delegate:ResourceContentHash(1_499_186_467)
internal val Res.string.admin_content_discard: StringResource by lazy {
      StringResource("string:admin_content_discard", "admin_content_discard", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5495, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4507, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4183, 41),
      ))
    }

@delegate:ResourceContentHash(-367_521_828)
internal val Res.string.admin_content_discard_message: StringResource by lazy {
      StringResource("string:admin_content_discard_message", "admin_content_discard_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5361, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4401, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4085, 97),
      ))
    }

@delegate:ResourceContentHash(1_882_973_325)
internal val Res.string.admin_content_kind_fact: StringResource by lazy {
      StringResource("string:admin_content_kind_fact", "admin_content_kind_fact", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5533, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4549, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4225, 47),
      ))
    }

@delegate:ResourceContentHash(990_328_780)
internal val Res.string.admin_content_kind_joke: StringResource by lazy {
      StringResource("string:admin_content_kind_joke", "admin_content_kind_joke", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5585, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4601, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4273, 39),
      ))
    }

@delegate:ResourceContentHash(-1_327_028_510)
internal val Res.string.admin_content_kind_news: StringResource by lazy {
      StringResource("string:admin_content_kind_news", "admin_content_kind_news", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5625, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4641, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4313, 39),
      ))
    }

@delegate:ResourceContentHash(-1_224_375_428)
internal val Res.string.admin_content_kind_recipe: StringResource by lazy {
      StringResource("string:admin_content_kind_recipe", "admin_content_kind_recipe", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5665, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4689, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4353, 41),
      ))
    }

@delegate:ResourceContentHash(-599_806_558)
internal val Res.string.admin_content_publish: StringResource by lazy {
      StringResource("string:admin_content_publish", "admin_content_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5723, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4735, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4395, 41),
      ))
    }

@delegate:ResourceContentHash(873_360_993)
internal val Res.string.admin_content_source: StringResource by lazy {
      StringResource("string:admin_content_source", "admin_content_source", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5769, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4777, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4437, 44),
      ))
    }

@delegate:ResourceContentHash(1_905_485_919)
internal val Res.string.admin_dismiss: StringResource by lazy {
      StringResource("string:admin_dismiss", "admin_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5830, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4830, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4482, 33),
      ))
    }

@delegate:ResourceContentHash(-1_912_787_027)
internal val Res.string.admin_edited_badge: StringResource by lazy {
      StringResource("string:admin_edited_badge", "admin_edited_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5872, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4864, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4516, 46),
      ))
    }

@delegate:ResourceContentHash(-1_925_149_276)
internal val Res.string.admin_edited_section: StringResource by lazy {
      StringResource("string:admin_edited_section", "admin_edited_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5943, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4919, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4563, 56),
      ))
    }

@delegate:ResourceContentHash(-784_648_359)
internal val Res.string.admin_empty_desc: StringResource by lazy {
      StringResource("string:admin_empty_desc", "admin_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6028, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4992, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4620, 96),
      ))
    }

@delegate:ResourceContentHash(913_813_765)
internal val Res.string.admin_empty_title: StringResource by lazy {
      StringResource("string:admin_empty_title", "admin_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6185, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5105, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4717, 37),
      ))
    }

@delegate:ResourceContentHash(733_629_119)
internal val Res.string.admin_error: StringResource by lazy {
      StringResource("string:admin_error", "admin_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6255, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5155, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4755, 59),
      ))
    }

@delegate:ResourceContentHash(-851_436_496)
internal val Res.string.admin_events_section: StringResource by lazy {
      StringResource("string:admin_events_section", "admin_events_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6343, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5239, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4815, 48),
      ))
    }

@delegate:ResourceContentHash(-82_843_715)
internal val Res.string.admin_growth_businesses: StringResource by lazy {
      StringResource("string:admin_growth_businesses", "admin_growth_businesses", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6420, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5300, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4864, 43),
      ))
    }

@delegate:ResourceContentHash(-61_356_881)
internal val Res.string.admin_growth_empty: StringResource by lazy {
      StringResource("string:admin_growth_empty", "admin_growth_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6476, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5348, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4908, 102),
      ))
    }

@delegate:ResourceContentHash(304_374_896)
internal val Res.string.admin_growth_subtitle: StringResource by lazy {
      StringResource("string:admin_growth_subtitle", "admin_growth_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6655, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5483, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5011, 81),
      ))
    }

@delegate:ResourceContentHash(685_991_748)
internal val Res.string.admin_growth_title: StringResource by lazy {
      StringResource("string:admin_growth_title", "admin_growth_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6793, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5569, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5093, 50),
      ))
    }

@delegate:ResourceContentHash(1_895_547_089)
internal val Res.string.admin_growth_users: StringResource by lazy {
      StringResource("string:admin_growth_users", "admin_growth_users", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6844, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5624, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5144, 38),
      ))
    }

@delegate:ResourceContentHash(1_096_299_571)
internal val Res.string.admin_listing_request_approve_removal: StringResource by lazy {
      StringResource("string:admin_listing_request_approve_removal", "admin_listing_request_approve_removal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6891, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5663, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5183, 69),
      ))
    }

@delegate:ResourceContentHash(1_791_401_439)
internal val Res.string.admin_listing_request_correction: StringResource by lazy {
      StringResource("string:admin_listing_request_correction", "admin_listing_request_correction", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6965, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5737, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5253, 56),
      ))
    }

@delegate:ResourceContentHash(1_932_586_532)
internal val Res.string.admin_listing_request_privacy: StringResource by lazy {
      StringResource("string:admin_listing_request_privacy", "admin_listing_request_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7022, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5794, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5310, 49),
      ))
    }

@delegate:ResourceContentHash(-1_197_629_315)
internal val Res.string.admin_listing_request_reject: StringResource by lazy {
      StringResource("string:admin_listing_request_reject", "admin_listing_request_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7088, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5856, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5360, 44),
      ))
    }

@delegate:ResourceContentHash(1_029_974_784)
internal val Res.string.admin_listing_request_removal: StringResource by lazy {
      StringResource("string:admin_listing_request_removal", "admin_listing_request_removal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7359, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6079, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5579, 49),
      ))
    }

@delegate:ResourceContentHash(1_893_772_173)
internal val Res.string.admin_listing_request_removal_confirm: StringResource by lazy {
      StringResource("string:admin_listing_request_removal_confirm", "admin_listing_request_removal_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7133, 225),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5905, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5405, 173),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("admin_all_listings_empty", Res.string.admin_all_listings_empty)
  map.put("admin_all_listings_search", Res.string.admin_all_listings_search)
  map.put("admin_all_listings_section", Res.string.admin_all_listings_section)
  map.put("admin_approve", Res.string.admin_approve)
  map.put("admin_audit_actor", Res.string.admin_audit_actor)
  map.put("admin_audit_line", Res.string.admin_audit_line)
  map.put("admin_audit_section", Res.string.admin_audit_section)
  map.put("admin_back_a11y", Res.string.admin_back_a11y)
  map.put("admin_brand", Res.string.admin_brand)
  map.put("admin_brand_sub", Res.string.admin_brand_sub)
  map.put("admin_camp_all_canada", Res.string.admin_camp_all_canada)
  map.put("admin_camp_audience", Res.string.admin_camp_audience)
  map.put("admin_camp_body_en", Res.string.admin_camp_body_en)
  map.put("admin_camp_body_fa", Res.string.admin_camp_body_fa)
  map.put("admin_camp_body_fr", Res.string.admin_camp_body_fr)
  map.put("admin_camp_capped", Res.string.admin_camp_capped)
  map.put("admin_camp_channel", Res.string.admin_camp_channel)
  map.put("admin_camp_channel_email", Res.string.admin_camp_channel_email)
  map.put("admin_camp_channel_push", Res.string.admin_camp_channel_push)
  map.put("admin_camp_dest", Res.string.admin_camp_dest)
  map.put("admin_camp_dest_business", Res.string.admin_camp_dest_business)
  map.put("admin_camp_dest_event", Res.string.admin_camp_dest_event)
  map.put("admin_camp_dest_id", Res.string.admin_camp_dest_id)
  map.put("admin_camp_dest_item", Res.string.admin_camp_dest_item)
  map.put("admin_camp_dest_post", Res.string.admin_camp_dest_post)
  map.put("admin_camp_dest_url", Res.string.admin_camp_dest_url)
  map.put("admin_camp_email_note", Res.string.admin_camp_email_note)
  map.put("admin_camp_failed", Res.string.admin_camp_failed)
  map.put("admin_camp_hint", Res.string.admin_camp_hint)
  map.put("admin_camp_send", Res.string.admin_camp_send)
  map.put("admin_camp_sending", Res.string.admin_camp_sending)
  map.put("admin_camp_sent", Res.string.admin_camp_sent)
  map.put("admin_camp_target_missing", Res.string.admin_camp_target_missing)
  map.put("admin_camp_title_en", Res.string.admin_camp_title_en)
  map.put("admin_camp_title_fa", Res.string.admin_camp_title_fa)
  map.put("admin_camp_title_fr", Res.string.admin_camp_title_fr)
  map.put("admin_campaigns_section", Res.string.admin_campaigns_section)
  map.put("admin_cancel", Res.string.admin_cancel)
  map.put("admin_change_address", Res.string.admin_change_address)
  map.put("admin_change_apply", Res.string.admin_change_apply)
  map.put("admin_change_category", Res.string.admin_change_category)
  map.put("admin_change_name", Res.string.admin_change_name)
  map.put("admin_change_reject", Res.string.admin_change_reject)
  map.put("admin_changes_section", Res.string.admin_changes_section)
  map.put("admin_chip_audit", Res.string.admin_chip_audit)
  map.put("admin_chip_businesses", Res.string.admin_chip_businesses)
  map.put("admin_chip_campaigns", Res.string.admin_chip_campaigns)
  map.put("admin_chip_claims", Res.string.admin_chip_claims)
  map.put("admin_chip_content", Res.string.admin_chip_content)
  map.put("admin_chip_events", Res.string.admin_chip_events)
  map.put("admin_chip_listings", Res.string.admin_chip_listings)
  map.put("admin_chip_members", Res.string.admin_chip_members)
  map.put("admin_chip_reports", Res.string.admin_chip_reports)
  map.put("admin_chip_requests", Res.string.admin_chip_requests)
  map.put("admin_claim_contact", Res.string.admin_claim_contact)
  map.put("admin_claim_deny", Res.string.admin_claim_deny)
  map.put("admin_claim_grant", Res.string.admin_claim_grant)
  map.put("admin_claim_proof_a11y", Res.string.admin_claim_proof_a11y)
  map.put("admin_claim_proof_close_a11y", Res.string.admin_claim_proof_close_a11y)
  map.put("admin_claim_requested_by", Res.string.admin_claim_requested_by)
  map.put("admin_claim_role", Res.string.admin_claim_role)
  map.put("admin_claim_role_employee", Res.string.admin_claim_role_employee)
  map.put("admin_claim_role_manager", Res.string.admin_claim_role_manager)
  map.put("admin_claim_role_other", Res.string.admin_claim_role_other)
  map.put("admin_claim_role_owner", Res.string.admin_claim_role_owner)
  map.put("admin_claim_verification", Res.string.admin_claim_verification)
  map.put("admin_claim_view_proof", Res.string.admin_claim_view_proof)
  map.put("admin_claims_section", Res.string.admin_claims_section)
  map.put("admin_col_actions", Res.string.admin_col_actions)
  map.put("admin_col_business", Res.string.admin_col_business)
  map.put("admin_col_category", Res.string.admin_col_category)
  map.put("admin_col_location", Res.string.admin_col_location)
  map.put("admin_col_member", Res.string.admin_col_member)
  map.put("admin_col_role", Res.string.admin_col_role)
  map.put("admin_content_discard", Res.string.admin_content_discard)
  map.put("admin_content_discard_message", Res.string.admin_content_discard_message)
  map.put("admin_content_kind_fact", Res.string.admin_content_kind_fact)
  map.put("admin_content_kind_joke", Res.string.admin_content_kind_joke)
  map.put("admin_content_kind_news", Res.string.admin_content_kind_news)
  map.put("admin_content_kind_recipe", Res.string.admin_content_kind_recipe)
  map.put("admin_content_publish", Res.string.admin_content_publish)
  map.put("admin_content_source", Res.string.admin_content_source)
  map.put("admin_dismiss", Res.string.admin_dismiss)
  map.put("admin_edited_badge", Res.string.admin_edited_badge)
  map.put("admin_edited_section", Res.string.admin_edited_section)
  map.put("admin_empty_desc", Res.string.admin_empty_desc)
  map.put("admin_empty_title", Res.string.admin_empty_title)
  map.put("admin_error", Res.string.admin_error)
  map.put("admin_events_section", Res.string.admin_events_section)
  map.put("admin_growth_businesses", Res.string.admin_growth_businesses)
  map.put("admin_growth_empty", Res.string.admin_growth_empty)
  map.put("admin_growth_subtitle", Res.string.admin_growth_subtitle)
  map.put("admin_growth_title", Res.string.admin_growth_title)
  map.put("admin_growth_users", Res.string.admin_growth_users)
  map.put("admin_listing_request_approve_removal", Res.string.admin_listing_request_approve_removal)
  map.put("admin_listing_request_correction", Res.string.admin_listing_request_correction)
  map.put("admin_listing_request_privacy", Res.string.admin_listing_request_privacy)
  map.put("admin_listing_request_reject", Res.string.admin_listing_request_reject)
  map.put("admin_listing_request_removal", Res.string.admin_listing_request_removal)
  map.put("admin_listing_request_removal_confirm", Res.string.admin_listing_request_removal_confirm)
}
